<template>
    <div class="page-container">
      <h3 class="main-text">
        Watashi no na wa “kirayoshikage” nenrei 33-sai jitaku wa moriōchō hokutō-bu no bessō chitai ni ari… kekkon wa shite inai… 
        shigoto wa “kameyūchēn-ten” no kaishain de mainichi osokutomo yoru 8-ji made ni wa kitaku suru tabako wa suwanai sake wa tashinamu 
        teido yoru 11 tokiniha yuka ni tsuki kanarazu 8-jikan wa suimin o toru yō ni shite iru… nerumae ni atatakai miruku o nomi 20-bu 
        hodo no sutoretchi de karada o hogushite kara yuka ni tsuku to hotondo asamade jukusui-sa… akanbō no yō ni hirō ya sutoresu o 
        nokosazu ni asa-me o samaseru nda… kenkōshinda demo ijō nashi to iwa reta yo
      </h3>
      <h4 class="italic">Shigechi talks</h4>
      <h3 class="main-text">
        Watashi wa tsuneni “kokoro no heion” o negatte iki teru ningen to iu koto o setsumei shite iru noda yo… “kachimake” ni kodawattari 
        atama o kakaeru yōna “toraburu” toka yoru mo nemurenai to itta “teki” o tsukuranai… to iu no ga watashi no shakai ni taisuru 
        shiseideari sore ga jibun no kōfukuda to iu koto o shitte iru… mottomo tatakatta to shite mo watashi wa darenimo makenga ne
      </h3>
      <img 
        src="https://c.tenor.com/XwAYECbLC9QAAAAd/tenor.gif" 
        alt="watashinonawakirayoshikagenenreisanjuusansaijitakuwamoriohcho"
        class="main-image"
      />
      <p>Desarrollado por Skull Kid</p>
      <button @click="navigateToExternal" class="discord-btn">
        Más sobre mí
      </button>
      <p class="credits">Estilos de la página por rutz_idk</p>
      <p class="credits">Propuesto por Mr. Pera Robótica</p>
      <p class="credits">Agradecimiento especial a Noian por crear un Dios que escapó a su control</p>
    </div>
    <AdSense />
    <AdSense />
    <AdSense />
  </template>
  
  <script>
  import AdSense from './AdSense.vue';
    export default {
      components: {
        AdSense
      },
      name: "AppDeveloper",
      methods: {
      navigateToExternal() {
        window.location.href = "https://x.com/cuurse_";
      },
    },
  };
  </script>
  
  <style scoped>
  .main-text {
    margin: 1rem 0;
    line-height: 1.8;
    color: #ffffff;
    text-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  }

  .italic {
    font-style: italic;
    color: #f1c40f;
  }

  .main-image {
    max-width: 100%;
    height: auto;
    border-radius: 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.6);
    margin: 1.5rem 0;
  }

  .credits {
  margin: 0.5rem 0;
  font-size: 0.9rem;
  color: #cccccc;
}

  @media (max-width: 768px) {
    .main-text {
      font-size: 1rem;
    }

    .discord-btn {
      font-size: 1rem;
      padding: 0.5rem 1rem;
    }
  }
  </style>